<label class="label" *ngIf="label">{{ label }}</label>
<div class="input-box" class="appearance-{{ appearance }}">
  <ng-content select="input"></ng-content>
  <ng-content select="[suiFormFieldSuffix]"></ng-content>
  <ng-content select="sui-form-field-hint"></ng-content>
</div>
